import React from 'react';
import { useTranslation } from 'react-i18next';
import { User, Mail, Phone } from 'lucide-react';
import Navbar from '../components/layout/Navbar';
import Footer from '../components/layout/Footer';
import { Card, CardContent, CardHeader, CardTitle } from '../components/ui/card';
import { getUser } from '../utils/auth';

const ProfilePage = () => {
  const { i18n } = useTranslation();
  const user = getUser();

  return (
    <div className="min-h-screen" data-testid="profile-page">
      <Navbar />
      <main className="pt-24 pb-12 px-4">
        <div className="max-w-4xl mx-auto">
          <h1 className="text-4xl font-bold mb-8">
            {i18n.language === 'ar' ? 'الملف الشخصي' : 'Profile'}
          </h1>

          <Card className="card">
            <CardHeader>
              <div className="flex items-center gap-4">
                <div className="w-20 h-20 rounded-full bg-gradient-to-br from-primary to-primary-light flex items-center justify-center">
                  <User className="w-10 h-10 text-white" />
                </div>
                <div>
                  <CardTitle className="text-2xl">{user?.full_name}</CardTitle>
                  <p className="text-text-secondary capitalize">{user?.role}</p>
                </div>
              </div>
            </CardHeader>
            <CardContent className="space-y-6">
              <div className="flex items-center gap-4 p-4 bg-background rounded-lg">
                <Mail className="w-6 h-6 text-primary" />
                <div>
                  <p className="text-sm text-text-secondary mb-1">
                    {i18n.language === 'ar' ? 'البريد الإلكتروني' : 'Email'}
                  </p>
                  <p className="font-medium">{user?.email}</p>
                </div>
              </div>

              {user?.phone && (
                <div className="flex items-center gap-4 p-4 bg-background rounded-lg">
                  <Phone className="w-6 h-6 text-primary" />
                  <div>
                    <p className="text-sm text-text-secondary mb-1">
                      {i18n.language === 'ar' ? 'رقم الجوال' : 'Phone'}
                    </p>
                    <p className="font-medium" dir="ltr">{user.phone}</p>
                  </div>
                </div>
              )}
            </CardContent>
          </Card>
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default ProfilePage;
